import { useState, useEffect } from "react";
import { httpService } from "../../services/httpService";
import { RiCloseCircleFill } from "react-icons/ri";
import { HiArrowSmLeft } from "react-icons/hi";
import PetServiceCategoryDrawer from "../Orders/PetServiceCategoryDrawer";
import AddNewPet from "../Orders/AddNewPet";
import { toast } from "react-toastify";
import { format } from "date-fns";
import {
  FiPhone,
  FiUser,
  FiMail,
  FiMapPin,
  FiEdit3,
  FiCalendar,
  FiPlusCircle,
  FiArrowRightCircle,
  FiX,
} from "react-icons/fi";
import { Typography, TextField, Grid } from "@mui/material";
import NotesIcon from "@mui/icons-material/Notes";
import {
  MdPets,
  MdLocalHotel,
  MdShoppingCart,
  MdHistory,
  MdSpa,
  MdPayment,
} from "react-icons/md";
import Swal from "sweetalert2";
import {
  FaDirections,
  FaPaw,
  FaSortNumericUp,
  FaDog,
  FaClock,
  FaUserTie,
  FaCalendar,
  FaInfoCircle,
  FaCat,
} from "react-icons/fa";
import ScheduleDrawer from "../../components/Order/ScheduleDrawer";
import CombinedHistoryDrawer from "./BigCalendar/bookingcalendar/CombinedHistoryDrawer";
import AddonIcon from "../../components/Icons/AddonIcon";
import SelectAddOnsDrawer from "../Orders/SelectAddOnsDrawer";
import PaymentDrawer from "../../components/Order/PaymentDrawer";
import TotalsSummary from "../common/TotalsSummary";

const EditEnquiry = ({
  isOpen,
  onClose,
  onSave,
  appointmentStatusRef,
  enquiryDetails,
  clientDetails,
}) => {
  const [clientData, setClientData] = useState(null);
  const [shouldOpenPetForm, setShouldOpenPetForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPetServiceDrawer, setShowPetServiceDrawer] = useState(false);
  const [showAddNewPet, setShowAddNewPet] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [appointmentList, setAppointmentList] = useState([]);
  const [boardingList, setBoardingList] = useState([]);
  const [vetClinicList, setVetClinicList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [totalSummary, setTotalSummary] = useState({
    subtotal: 0,
    gst: 0,
    discount: 0,
    total: 0,
    discountAmount: 0,
    discountedGST: 0,
  });

  const [paymentDetails, setPaymentDetails] = useState({
    paymentType: "", // 'full', 'partial'
    amount: "",
    method: "", // 'cash', 'upi', 'credit', 'cheque', 'bank'
    reference: "",
    notes: "",
  });
  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [isBookingLoading, setIsBookingLoading] = useState(false);
  const [isServiceEditMode, setIsServiceEditMode] = useState(false);

  // Booking Details Drawer for the schedule button
  // const [showBookingDetails, setShowBookingDetails] = useState(false);
  // const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [saveDisabled, setSaveDisabled] = useState(false);

  // schedule drawer open close drawer functions
  // const handleOpenScheduleDetails = (orderId) => {
  //   setSelectedOrderId(orderId);
  //   setShowBookingDetails(true);
  // };

  // const handleCloseScheduleDetails = () => {
  //   setShowBookingDetails(false);
  //   setSelectedOrderId(null);
  // };

  const [newOrderDetails, setNewOrderDetails] = useState(null);
  const [loadingNewOrder, setLoadingNewOrder] = useState(false);
  const [showHistoryDrawer, setShowHistoryDrawer] = useState(false);
  const [enquiryData, setEnquiryData] = useState([]);
  const [notes, setNotes] = useState("");

  const [discount, setDiscount] = useState({
    type: "percentage", // percentage | fixed
    value: 0,
    amount: 0,
  });

  //Addons States
  const [isAddonsDrawerOpen, setIsAddonsDrawerOpen] = useState(false);
  const [addonsServiceCategoryId, setAddonsServiceCategoryId] = useState(null);
  const [addonsPetType, setAddonsPetType] = useState("Both");
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [selectedListType, setSelectedListType] = useState(null); // e.g. "appointmentList", "vetClinicList"
  const [serviceTypeName, setServiceTypeName] = useState("");

  const handleOpenAddonsDrawer = (item, index, listType) => {
    setAddonsServiceCategoryId(
      item.service_category_type_id || item.service_type_id
    );
    setAddonsPetType(item.pet_type);
    setSelectedAddons(item.addons || []);
    setSelectedItemIndex(index);
    setSelectedListType(listType);
    setIsAddonsDrawerOpen(true);
    setServiceTypeName(item.service_type_name);
  };

  const handleCloseAddons = () => {
    setIsAddonsDrawerOpen(false);
  };
  const handleSaveAddons = (updatedAddons) => {
    setIsAddonsDrawerOpen(false);
    if (!updatedAddons || selectedItemIndex === null || !selectedListType)
      return;

    switch (selectedListType) {
      case "appointmentList":
        setAppointmentList((prev) => {
          const updated = [...prev];
          updated[selectedItemIndex].addons = updatedAddons;
          return updated;
        });
        break;

      case "vetClinicList":
        setVetClinicList((prev) => {
          const updated = [...prev];
          updated[selectedItemIndex].addons = updatedAddons;
          return updated;
        });
        break;

      case "boardingList":
        setBoardingList((prev) => {
          const updated = [...prev];
          updated[selectedItemIndex].addons = updatedAddons;
          return updated;
        });
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    let calcValue = discount.value;

    // Validation
    if (discount.type === "percentage" && calcValue > 100) {
      calcValue = 100;
    } else if (
      discount.type === "fixed" &&
      Number(totalSummary.subtotal) > 0 &&
      calcValue > Number(totalSummary.subtotal)
    ) {
      calcValue = Number(totalSummary.subtotal);
    }

    // Calculate discount amount
    const calcAmount =
      discount.type === "percentage"
        ? (totalSummary.subtotal * calcValue) / 100
        : calcValue;

    // Convert flat to percentage if needed
    const discountPercent =
      discount.type === "percentage"
        ? calcValue
        : (calcValue / totalSummary.subtotal) * 100;

    setDiscount((prev) => ({ ...prev, value: calcValue, amount: calcAmount }));
  }, [discount.type, discount.value, totalSummary.subtotal, totalSummary.gst]);

  //directly set client if client details are passed
  useEffect(() => {
    if (clientDetails && clientDetails?.phone) {
      fetchClientByPhone(clientDetails.phone);
    }
  }, [clientDetails]);

  // Fetch client by phone
  const fetchClientByPhone = async (phone) => {
    if (phone.length !== 10) return;

    setLoading(true);
    setError(null);
    try {
      const response = await httpService.get(`/vendorclient/search/${phone}`);
      const client = response.data || null;
      setClientData(client);
    } catch (err) {
      setError("Client not found or error fetching data.");
      setClientData(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchRooms = async () => {
    try {
      const response = await httpService.get("/room/getRooms");
      setRooms(response?.data || []);
    } catch (err) {
      setRooms([]);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchRooms();
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      const initialDiscountType =
        enquiryDetails?.discount_type === "fixed" ? "fixed" : "percentage";
      const initialDiscountAmount = Number(
        enquiryDetails?.discount_amount ?? enquiryDetails?.total_discount ?? 0
      );
      const initialDiscountValue = Number(
        enquiryDetails?.discount_value ?? initialDiscountAmount
      );

      setDiscount({
        type: initialDiscountType,
        value: initialDiscountValue,
        amount: initialDiscountAmount,
      });
      setTotalSummary({
        subtotal: Number(
          enquiryDetails?.sub_total_amount ?? enquiryDetails?.amount_before_discount ?? 0
        ).toFixed(2),
        gst: Number(
          enquiryDetails?.gst_after_discount ?? enquiryDetails?.total_gst ?? 0
        ).toFixed(2),
        discount: initialDiscountAmount.toFixed(2),
        total: Number(
          enquiryDetails?.total_amount ?? enquiryDetails?.amount_after_discount ?? 0
        ).toFixed(2),
        discountAmount: initialDiscountAmount,
        discountedGST: Number(
          enquiryDetails?.gst_after_discount ?? enquiryDetails?.total_gst ?? 0
        ),
      });
      setNotes("");
      if (enquiryDetails) {
        setNotes(enquiryDetails?.notes || "");
        if (enquiryDetails?.items?.length) {
          const newBoardingList = [];
          const newAppointmentList = [];

          enquiryDetails.items.forEach((data) => {
            if (!data.type) return;
            const type = data.type.toLowerCase();

            if (
              type === "boarding" ||
              type === "day_care" ||
              type === "daycare"
            ) {
              const isBoarding = type === "boarding";
              const isDaycare = type === "day_care" || type === "daycare";

              const newItemData = {
                ...data,
                pet_name: data.pet_name,
                service_type_name:
                  data.service_type_name ||
                  (isDaycare ? "Day Care" : "Boarding"),
                service_type_id: data.service_type_id,
                pet_breed: data.pet_breed,
                pet_type: data.pet_type,
                pet_size: getPetSizeValue(data),
                unit_price: data.unit_price,
                total_price: data.total_price,
                discount: data.discount || 0,
                gst: data.gst || 0,
                tax_percentage: data.tax_percentage || 0,
                item_type: type,
              };

              if (isBoarding) {
                newItemData.room_type_name = getRoomTypeNameValue(data);
                newItemData.room_type_id = getRoomTypeIdValue(data);
                newItemData.room_number = getRoomNumberValue(data);
                newItemData.room_id = getRoomIdValue(data);
                newBoardingList.push(newItemData);
              } else if (isDaycare) {
                const daycareItemData = {
                  ...newItemData,
                  service_id: data.service_id,
                };
                newAppointmentList.push(daycareItemData);
              }
            } else {
              // dog_walking or general appointment
              const newItemData = {
                ...data,
                service_type_name: data.service_type_name || "Dog Walking",
                item_type: type,
              };
              newAppointmentList.push(newItemData);
            }
          });

          // Batch update state
          setBoardingList(newBoardingList);
          setAppointmentList(newAppointmentList);

          // Call fetchDiscountData only once
          // fetchDiscountData([...newAppointmentList, ...newBoardingList]);
        }
      }
    }
  }, [isOpen, enquiryDetails.items]);

  // Fetch new order details after saving
  const fetchNewOrderDetails = async (appointmentId) => {
    setLoadingNewOrder(true);
    try {
      const response = await httpService.get(
        `/vendorappointment/getVendorAppointment/${appointmentId}`
      );
      if (response?.data) {
        setNewOrderDetails(response.data);
      }
    } catch (err) {
      console.error("Error fetching new order details:", err);
    } finally {
      setLoadingNewOrder(false);
    }
  };

  const handleClose = () => {
    resetForm();
    onClose();

    // Refresh boarding calendar and queue data when drawer closes
    if (window.refreshBoardingData || window.refreshBookingData) {
      if (window.refreshBoardingData) {
        window.refreshBoardingData();
      } else {
        window.refreshBookingData();
      }
    }
  };

  const resetForm = () => {
    setClientData(null);
    setShouldOpenPetForm(false);
    setLoading(false);
    setError(null);
    setShowPetServiceDrawer(false);
    setShowAddNewPet(false);
    setNewOrderDetails(null);
    setLoadingNewOrder(false);
    setAppointmentList([]);
    setBoardingList([]);
    setProductList([]);
  };

  // Function to handle back navigation without losing appointment state
  const handleBackFromServiceDrawer = () => {
    setShowPetServiceDrawer(false);
    setItemData([]); // Clear item data but keep appointment list intact
    // setDrawerEditMode(false); // Reset edit mode
    // Don't reset appointmentList here to maintain state
  };

  const handleProductQuantityChange = (index, delta) => {
    setProductList((prev) => {
      const next = [...prev];
      const newQuantity = next[index].quantity + delta;
      const availableQuantity = next[index].quantity_available;
      next[index] = { ...next[index], quantity: next[index].quantity + delta };

      // If quantity drops to zero or below, remove the item entirely
      if (newQuantity <= 0) {
        next.splice(index, 1);
      } else if (newQuantity > availableQuantity) {
        toast.warn(`Only ${availableQuantity} items available`);
        next[index].quantity = availableQuantity;
        // Recompute total_price
        next[index].total_price = availableQuantity * next[index].unit_price;
        next[index].gstAmount =
          (next[index].unit_price - next[index].before_gst) *
          next[index].quantity;
      } else {
        next[index].total_price = next[index].quantity * next[index].unit_price;
        next[index].gstAmount =
          (next[index].unit_price - next[index].before_gst) *
          next[index].quantity;
      }
      // Safely handle gstAmount - only update if it exists
      if (next[index] && typeof next[index].gstAmount !== "undefined") {
        next[index].gstAmount = next[index].gstAmount * next[index].quantity;
      }
      return next;
    });
  };
  const handleProductQuantityInput = (idx, value, product) => {
    let qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
    }

    if (qty > product.quantity_available) {
      toast.warn(`Only ${product.quantity_available} items available`);
      qty = product.quantity_available;
    }

    setProductList((prev) => {
      const updated = [...prev];
      updated[idx] = {
        ...product,
        quantity: qty,
        total_price: qty * product.unit_price,
        // Safely handle gstAmount - only include if it exists in the original product
        ...(product.gstAmount !== undefined && {
          gstAmount: product.gstAmount * qty,
        }),
      };
      return updated;
    });
  };

  const handleSavedAppointment = (data) => {
    // Check if this is appointment data from NewServiceDrawer (not API response)
    if (data.pet_name && data.service_name && !data._id) {
      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        // This is an update to an existing appointment in the list
        const editIndex = data._editIndex;
        setAppointmentList((prev) => {
          const updatedList = [...prev];
          // Update the appointment at the specific index
          const updatedData = { ...data };
          delete updatedData._editIndex; // Remove the index marker
          delete updatedData._originalAppointment; // Remove the backup data
          updatedList[editIndex] = updatedData; // Replace at the same position
          fetchDiscountData([...updatedList, ...boardingList]);
          return updatedList;
        });
        toast.success("Appointment updated successfully!", {
          position: "top-center",
        });
      } else {
        // This is a new appointment being added
        setAppointmentList((prev) => {
          const updatedList = [...prev, data];
          fetchDiscountData([...updatedList, ...boardingList]);
          return updatedList;
        });
        toast.success("Appointment added successfully!", {
          position: "top-center",
        });
      }
      setShowPetServiceDrawer(false); // Close the service drawer
      // Don't close the main appointment drawer - stay to show the data
      return;
    } else if (data.item_type === "product" && !data._id) {
      setProductList((prev = []) => {
        const map = new Map();

        // First, keep all previous values in a map (keyed by service_id)
        prev.forEach((p) => {
          map.set(p.service_id, p);
        });

        // Then, overwrite with new values (same service_id will be replaced)
        data.products.forEach((p) => {
          const updatedProduct = {
            ...p,
            gstAmount: p.gstAmount * p.quantity, // calculate gstAmount*quantity
          };
          map.set(p.service_id, updatedProduct);
        });

        // Return merged list
        return Array.from(map.values());
      });
    }
  };

  const handleSavedBoarding = (data) => {
    // Check if this is boarding data from BoardingDrawer (not API response)
    if (
      data.pet_name &&
      (data.item_type === "boarding" ||
        data.item_type === "daycare" ||
        data.item_type === "day_care") &&
      !data._id
    ) {
      // Determine which list to update based on item_type
      const isBoarding = data.item_type === "boarding";
      const isDaycare =
        data.item_type === "day_care" || data.item_type === "daycare";

      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        // This is an update to an existing item in the list
        const editIndex = data._editIndex;

        if (isBoarding) {
          setBoardingList((prev) => {
            const updatedList = [...prev];
            // Update the boarding at the specific index with all necessary fields
            const updatedData = {
              ...data,
              // Ensure all required fields are preserved, including updated pet name
              pet_name: data.pet_name,
              service_type_name: data.service_type_name,
              service_type_id: data.service_type_id,
              pet_breed: data.pet_breed,
              pet_type: data.pet_type,
              pet_size: getPetSizeValue(data),
              room_type_id: getRoomTypeIdValue(data),
              room_type_name: getRoomTypeNameValue(data),
              room_id: getRoomIdValue(data),
              room_number: getRoomNumberValue(data),
              unit_price: data.unit_price,
              total_price: data.total_price,
              discount: data.discount || 0,
              gst: data.gst || 0,
              tax_percentage: data.tax_percentage || 0,
            };
            delete updatedData._editIndex; // Remove the index marker
            delete updatedData._originalBoarding; // Remove the backup data
            updatedList[editIndex] = updatedData; // Replace at the same position
            fetchDiscountData([...appointmentList, ...updatedList]);
            return updatedList;
            // return updatedList;
          });
        } else if (isDaycare) {
          setAppointmentList((prev) => {
            const updatedList = [...prev];
            // Update the daycare at the specific index
            const updatedData = {
              ...data,
              // Ensure all required fields are preserved
              pet_name: data.pet_name,
              service_type_name: data.service_type_name || "Day Care",
              service_type_id: data.service_type_id,
              service_id: data.service_id, // Explicitly preserve service_id
              pet_breed: data.pet_breed,
              pet_type: data.pet_type,
              pet_size: getPetSizeValue(data),
              unit_price: data.unit_price,
              total_price: data.total_price,
              discount: data.discount || 0,
              gst: data.gst || 0,
            };
            delete updatedData._editIndex; // Remove the index marker
            delete updatedData._originalDaycare; // Remove the backup data
            updatedList[editIndex] = updatedData; // Replace at the same position
            fetchDiscountData([...updatedList, ...boardingList]);
            return updatedList;
          });
        }
      } else {
        // This is a new item being added
        const newItemData = {
          ...data,
          // Ensure all required fields are included
          pet_name: data.pet_name,
          service_type_name:
            data.service_type_name || (isDaycare ? "Day Care" : "Boarding"),
          service_type_id: data.service_type_id,
          pet_breed: data.pet_breed,
          pet_type: data.pet_type,
          pet_size: getPetSizeValue(data),
          unit_price: data.unit_price,
          total_price: data.total_price,
          discount: data.discount || 0,
          gst: data.gst || 0,
          tax_percentage: data.tax_percentage || 0,
        };

        if (isBoarding) {
          newItemData.room_type_name = getRoomTypeNameValue(data);
          newItemData.room_type_id = getRoomTypeIdValue(data);
          newItemData.room_number = getRoomNumberValue(data);
          newItemData.room_id = getRoomIdValue(data);
          setBoardingList((prev) => {
            const updatedList = [...prev, newItemData];
            fetchDiscountData([...appointmentList, ...updatedList]);
            return updatedList; // call your function here
          });

          // setBoardingList((prev) => [...prev, newItemData]);
        } else if (isDaycare) {
          // Ensure service_id is explicitly preserved for new daycare items
          const daycareItemData = {
            ...newItemData,
            service_id: data.service_id, // Explicitly preserve service_id
          };
          setAppointmentList((prev) => {
            const newList = [...prev, daycareItemData];
            fetchDiscountData([...newList, ...boardingList]);
            return newList;
          });
        }
      }
      setShowPetServiceDrawer(false); // Close the service drawer

      // Refresh boarding calendar and queue data after successful operation
      if (window.refreshBoardingData) {
        window.refreshBoardingData();
      } else if (window.refreshBookingData) {
        window.refreshBookingData();
      }

      // Don't close the main appointment drawer - stay to show the data
      return;
    } else if (data.item_type === "product" && !data._id) {
      setProductList((prev = []) => {
        const map = new Map();

        // First, keep all previous values in a map (keyed by service_id)
        prev.forEach((p) => {
          map.set(p.service_id, p);
        });

        // Then, overwrite with new values (same service_id will be replaced)
        data.products.forEach((p) => {
          const updatedProduct = {
            ...p,
            gstAmount: (p.gstAmount || 0) * (p.quantity || 1), // calculate gstAmount*quantity
          };
          map.set(p.service_id, updatedProduct);
        });

        // Return merged list
        return Array.from(map.values());
      });
    }
  };

  const handleSavedDogWalking = (data) => {
    // Check if this is dog walking data from DogWalkingDrawer (not API response)
    if (data.pet_name && data.item_type === "dog_walking" && !data._id) {
      // Check if this is an edit operation (has _editIndex)
      if (data._editIndex !== undefined) {
        // This is an update to an existing dog walking in the list
        const editIndex = data._editIndex;
        setAppointmentList((prev) => {
          const updatedList = [...prev];
          // Update the dog walking at the specific index with all necessary fields
          const updatedData = {
            ...data,
            // Ensure all required fields are preserved
            pet_name: data.pet_name,
            service_type_name: data.service_type_name || "Dog Walking",
            service_type_id: data.service_type_id,
            pet_breed: data.pet_breed,
            pet_type: data.pet_type,
            pet_size: getPetSizeValue(data),
            employee_name: data.employee_name,
            employee_id: data.technician_id,
            appointment_date: getStartDateValue(data),
            appointment_time: data.start_time,
            frequency: data.frequency,
            numberOfTimes: data.numberOfTimes,
            unit_price: data.unit_price,
            total_price: data.total_price,
            discount: data.discount || 0,
            gst: data.gst || 0,
            duration: data.duration,
            notes: data.notes,
          };
          delete updatedData._editIndex; // Remove the index marker
          delete updatedData._originalDogWalking; // Remove the backup data
          updatedList[editIndex] = updatedData; // Replace at the same position
          fetchDiscountData([...updatedList, ...boardingList]);
          return updatedList;
        });
        toast.success("Dog walking appointment updated successfully!", {
          position: "top-center",
        });
      } else {
        // This is a new dog walking being added
        const newItemData = {
          ...data,
          // Ensure all required fields are included
          pet_name: data.pet_name,
          service_type_name: data.service_type_name || "Dog Walking",
          service_type_id: data.service_type_id,
          pet_breed: data.pet_breed,
          pet_type: data.pet_type,
          pet_size: getPetSizeValue(data),
          employee_name: data.employee_name,
          employee_id: data.technician_id,
          appointment_date: data.appointment_date || data.start_date,
          appointment_time: data.start_time,
          frequency: data.frequency,
          numberOfTimes: data.numberOfTimes,
          unit_price: data.unit_price,
          total_price: data.total_price,
          discount: data.discount || 0,
          gst: data.gst || 0,
          duration: data.duration,
          notes: data.notes,
        };
        setAppointmentList((prev) => {
          const updatedList = [...prev, newItemData];

          fetchDiscountData([...updatedList, ...boardingList]);
          return updatedList;
        });
        toast.success("Dog walking appointment added successfully!", {
          position: "top-center",
        });
      }
      setShowPetServiceDrawer(false); // Close the service drawer
      // Don't close the main appointment drawer - stay to show the data
      return;
    }
  };

  const handleSavedServicesData = (data) => {
    setIsServiceEditMode(false);
    // Route to appropriate handler based on service type
    if (
      data.item_type.toLowerCase() === "boarding" ||
      data.item_type === "day_care"
    ) {
      handleSavedBoarding(data);
    } else if (data?.item_type === "dog_walking") {
      // Route dog walking data to specific handler if available
      handleSavedDogWalking(data);
    } else {
      // For all other services (Grooming, Day Care, etc.)
      handleSavedAppointment(data);
    }

    // Original API response handling for actual saving
    const message = `Enquiry updated successfully!`;
    if (data._id) {
      toast.success(message, {
        position: "top-center",
      });
      // setOrderId(data._id);
      // setOrderItems(data.order_items);

      // Fetch the new order details if there's a ref_id
      if (
        data.order_items &&
        data.order_items.length > 0 &&
        data.order_items[0].ref_id
      ) {
        fetchNewOrderDetails(data.order_items[0].ref_id);
      }

      // Call parent save handler; also close drawers
      if (onSave) {
        onSave(data);
      }
      handleClose();
    }
  };
  const appendDiscountObjects = (arrayWithDiscount, arrayWithNumber) => {
    return arrayWithNumber.map((item, index) => {
      const source = arrayWithDiscount[index];
      return {
        ...item,
        discounts: source?.discount || [], // attach discount object here
      };
    });
  };

  const fetchDiscountData = async (items) => {
    try {
      const payload = {
        client_id: clientData?._id,
        items: items,
      };
      const response = await httpService.post(
        "/vendorbooking/getDiscountCalculation",
        payload
      );
      const itemsWithDiscount = appendDiscountObjects(
        response.data.items,
        items
      );
      setBoardingList(
        itemsWithDiscount.filter((item) => item.item_type === "boarding")
      );
      setAppointmentList(
        itemsWithDiscount.filter(
          (item) =>
            item.item_type === "grooming" ||
            item.item_type === "day_care" ||
            item.item_type === "vet_clinic" ||
            item.item_type === "dog_walking"
        )
      );
    } catch (error) {
      console.error("Error fetching discount data:", error);
    } finally {
    }
  };

  const handleServiceData = (serviceId) => {
    setItemData((prev) => ({
      ...prev,
      service_id: serviceId,
    }));
  };

  // Helper function to safely format dates
  const safeFormatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };

  const getMatchedPet = (item) => {
    const itemPetId =
      item?.pet_id || item?.vendor_pet_id;
    const itemPetName = item?.pet_name?.trim()?.toLowerCase();

    return (
      clientData?.pets?.find((pet) => {
        const petId = pet?._id;
        const petName = pet?.name?.trim()?.toLowerCase();
        return (itemPetId && petId === itemPetId) || (itemPetName && petName === itemPetName);
      }) || null
    );
  };

  const getPetSizeValue = (item) => {
    const matchedPet = getMatchedPet(item);

    return (
      item?.pet_size ||
      item?.size_details?.size_label ||
      matchedPet?.size_details?.size_label ||
      ""
    );
  };

  const getResolvedRoomInfo = (item) => {
    const roomTypeId = item?.room_type_id;
    const roomId = item?.room_id;

    let matchedRoom = rooms.find((room) => room?._id === roomTypeId) || null;

    if (!matchedRoom && roomId) {
      matchedRoom =
        rooms.find((room) =>
          room?.room_numbers?.some((roomNumber) => roomNumber?._id === roomId)
        ) || null;
    }

    const matchedBed =
      matchedRoom?.room_numbers?.find((bed) => bed?._id === roomId) || null;

    return {
      roomTypeId: matchedRoom?._id || item?.room_type_id || "",
      roomId: matchedBed?._id || item?.room_id || "",
      roomTypeName: matchedRoom?.room_name || item?.room_type_name || "",
      roomNumber: matchedBed?.room_number || item?.room_number || "",
  };
  };

  const getRoomNumberValue = (item) => getResolvedRoomInfo(item).roomNumber;

  const getRoomTypeNameValue = (item) => getResolvedRoomInfo(item).roomTypeName;

  const getRoomTypeIdValue = (item) => getResolvedRoomInfo(item).roomTypeId;

  const getRoomIdValue = (item) => getResolvedRoomInfo(item).roomId;


  const getStartDateValue = (item) =>
    item?.start_date || item?.appointment_date || "";

  const getEndDateValue = (item) => item?.end_date || "";

  // Helper function to get boarding display text
  const getBoardingDisplayText = (boarding) => {
    const roomTypeName = getRoomTypeNameValue(boarding);
    const roomNumber = getRoomNumberValue(boarding);

    if (roomTypeName && roomNumber) {
      return `Boarding - ${roomTypeName} - Room ${roomNumber}`;
    }

    if (roomTypeName) {
      return `Boarding - ${roomTypeName}`;
    }

    if (roomNumber) {
      return `Boarding - Room ${roomNumber}`;
    }

    return "Boarding - Room details not selected";
  };

  // Helper function to get boarding schedule text
  const getBoardingScheduleText = (boarding) => {
    const checkinDate = safeFormatDate(getStartDateValue(boarding));
    const checkoutDate = safeFormatDate(getEndDateValue(boarding));
    const duration = boarding.duration || "Duration not set";

    if (!checkinDate && !checkoutDate) {
      return `${duration} days • Check-in: Not selected • Check-out: Not selected`;
    } else if (!checkinDate) {
      return `${duration} days • Check-in: Not selected • Check-out: ${checkoutDate.toLocaleDateString()}`;
    } else if (!checkoutDate) {
      return `${duration} days • Check-in: ${checkinDate.toLocaleDateString()} • Check-out: Not selected`;
    } else {
      return `${duration} days • Check-in: ${checkinDate.toLocaleDateString()} • Check-out: ${checkoutDate.toLocaleDateString()}`;
    }
  };

  const getItemDiscountDetails = (item) => {
    const activeDiscount = item?.discounts?.find(
      (d) => Number(d?.is_active) === 1
    );
    const fallbackDiscountAmount = Number(
      item?.discount_amount ?? item?.discount ?? 0
    );
    const discountAmount = Number(
      activeDiscount?.discount_amount ?? fallbackDiscountAmount
    );
    const hasAnyDiscount = Boolean(activeDiscount || discountAmount > 0);

    return {
      activeDiscount,
      discountAmount: Number.isFinite(discountAmount) ? discountAmount : 0,
      hasAnyDiscount,
      discountName: activeDiscount?.name ?? item?.discount_name ?? "Discount",
      discountType: activeDiscount?.type ?? item?.discount_type,
      discountValue: activeDiscount?.value ?? item?.discount_value,
    };
  };

  const PriceWithDiscount = (item) => {
    const originalPriceRaw = item?.original_unit_price || (item?.unit_price ?? item?.total_price ?? 0);
    const duration = item?.type === "boarding" || item?.item_type === "boarding" ? Number(item.duration) : 1;
    const basePrice = Number(originalPriceRaw) * duration;
    const {
      activeDiscount,
      discountAmount,
      hasAnyDiscount,
      discountName,
      discountType,
      discountValue,
    } = getItemDiscountDetails(item);

    const rawResult = basePrice - discountAmount;
    const discountedPrice = Number.isFinite(rawResult) ? rawResult : 0;

    const discountAmountDisplay =
      hasAnyDiscount ? `₹ ${Number(discountAmount).toFixed(2)}` : null;

    const valueDisplay = hasAnyDiscount
      ? discountType === "percentage"
        ? `${discountValue}%`
        : discountValue != null
        ? `₹ ${Number(discountValue ?? 0).toFixed(2)}`
        : null
      : null;

    const discountList = (item?.discounts ?? [])
      .map((d, i) => {
        const name = d?.name ?? `Discount #${i + 1}`;
        const typeLabel =
          d?.type === "percentage"
            ? `${d?.value}%`
            : `₹ ${Number(d?.value ?? 0).toFixed(2)}`;
        const amount = `₹ ${Number(d?.discount_amount ?? 0).toFixed(2)}`;
        const activeFlag = Number(d?.is_active) === 1 ? " (active)" : "";
        return `${name} - ${typeLabel} (${amount})${activeFlag}`;
      })
      .join("\n");

    const tooltipId = `discount-tooltip-${
      item?.id ?? item?._id ?? Math.floor(Math.random() * 100000)
    }`;

    return (
      <>
        <span
          className={`text-gray-500 ${
            hasAnyDiscount ? "line-through" : "text-green-600 font-bold"
          }`}
        >
          ₹ {basePrice}
        </span>

        {hasAnyDiscount && (
          <span className="relative text-green-600 font-bold flex items-center gap-2">
            <span
              className="absolute inline-block group left-[-20px]"
              tabIndex={0}
              aria-describedby={tooltipId}
            >
              <FaInfoCircle className="text-sm text-gray-500" />
              <div
                id={tooltipId}
                role="tooltip"
                className="pointer-events-none absolute z-10 w-64 p-2 text-sm leading-tight text-white bg-gray-700 rounded shadow-lg opacity-0 scale-95 group-hover:opacity-100 group-focus:opacity-100 group-hover:scale-100 group-focus:scale-100 right-full mr-2 top-1/2 -translate-y-1/2 transform-gpu transition-all duration-200"
                style={{ whiteSpace: "pre-line" }}
              >
                {activeDiscount ? (
                  <>
                    <div className="font-semibold">
                      {formatName(activeDiscount?.name) ?? "Active Discount"}{" "}
                      Applied
                    </div>
                    {discountAmountDisplay && (
                      <div className="text-xs">
                        Discount amount: {discountAmountDisplay}
                        {valueDisplay && <span> ({valueDisplay})</span>}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="font-semibold">Available discounts</div>
                    <div className="text-xs mt-1">
                      {discountList || "No discount data"}
                    </div>
                  </>
                )}
              </div>
            </span>

            <span>₹ {discountedPrice.toFixed(2)}</span>
          </span>
        )}
      </>
    );
  };

  // Function to handle pet save from AddNewPet component
  const handlePetSaved = (petData) => {
    // Refresh pets list by re-fetching client data
    // if (clientData?.phone) {
    //     fetchClientByPhone(clientData.phone);
    // }
    setShowAddNewPet(false);
    // Optionally show a success message
    // toast.success('Pet added successfully! You can now add services for this pet.');
  };

  // Function to handle AddNewPet back button
  const handleAddNewPetBack = () => {
    setShowAddNewPet(false);
  };

  // Function to refresh appointment data
  const handleRefreshAppointmentData = (newData) => {
    if (onSave) {
      onSave(newData);
    }
  };

  // Handler for Add Pets & Services
  const handleAddPetsAndServices = () => {
    // setDrawerEditMode(false);
    setShowPetServiceDrawer(false);
    setTimeout(() => setShowPetServiceDrawer(true), 0);
  };

  // Handler for editing appointment from list
  const handleEditAppointmentFromList = (appointment, index) => {
    // Prepare the appointment data for editing with all necessary fields
    const editData = {
      ...appointment,
      // Ensure ids are present for downstream drawers
      service_id: appointment.service_id,
      pet_id: appointment.pet_id,
      vendor_pet_id: appointment.pet_id,
      vendor_client_id: clientData?._id,
      service_category_type_id: appointment.service_category_type_id,
      service_type_name:
        appointment.service_type_name || appointment.service_name || "Grooming",
      item_type:
        appointment.item_type ||
        (appointment.service_type_name === "Day Care"
          ? "day_care"
          : "grooming"), // Explicitly set item_type
      employee_id: appointment.technician_id,
      employee_name: appointment.employee_name,
      // Ensure date and time are properly formatted for editing
      start_date: getStartDateValue(appointment),
      start_time: appointment.start_time,
      appointment_date: appointment.appointment_date || getStartDateValue(appointment),
      appointment_time: appointment.appointment_time || appointment.start_time,
      // Preserve frequency and numberOfTimes for dog walking
      frequency: appointment.frequency,
      numberOfTimes: appointment.numberOfTimes,
      // Store the original index and appointment data for restoration
      _editIndex: index,
      _originalAppointment: { ...appointment },
    };

    setItemData(editData);
    // setDrawerEditMode(true);
    setShowPetServiceDrawer(true);
    // DON'T remove from list - keep it visible and handle updates properly
  };

  // Handler for deleting appointment from list
  const handleDeleteAppointmentFromList = (index) => {
    setAppointmentList((prev) => {
      const updatedList = prev.filter((_, i) => i !== index);
      fetchDiscountData([...updatedList, ...boardingList]);
      return updatedList;
    });
    toast.success("Appointment removed from list!", {
      position: "top-center",
    });
  };

  // Handler for editing boarding from list
  const handleEditBoardingFromList = (boarding, index) => {
    // Prepare the boarding data for editing with all necessary fields
    const editData = {
      ...boarding,
      // Ensure ids are present for downstream drawers
      service_id: boarding.service_id,
      pet_id: boarding.pet_id,
      vendor_pet_id: boarding.pet_id,
      vendor_client_id: clientData?._id,
      service_category_type_id: boarding.service_category_type_id,
      service_type_name: boarding.service_type_name || "Boarding", // Force to 'Boarding' for proper category matching
      service_type_id: boarding.service_type_id,
      item_type: "boarding", // Explicitly set item_type for better matching
      // Ensure dates are properly formatted for editing
      start_date: getStartDateValue(boarding),
      end_date: getEndDateValue(boarding),
      checkin_date: getStartDateValue(boarding),
      checkout_date: getEndDateValue(boarding),
      // Room and pricing details
      room_type_id: getRoomTypeIdValue(boarding),
      room_type_name: getRoomTypeNameValue(boarding),
      room_id: getRoomIdValue(boarding),
      room_number: getRoomNumberValue(boarding),
      price: boarding.unit_price,
      discount: boarding.discount || 0,
      gst: boarding.gst || 0,
      total_price: boarding.total_price,
      // Pet details
      pet_name: boarding.pet_name,
      pet_type: boarding.pet_type,
      pet_size: getPetSizeValue(boarding),
      pet_breed: boarding.pet_breed,
      // Store the original index and boarding data for restoration
      _editIndex: index,
      _originalBoarding: { ...boarding },
    };

    setItemData(editData);
    // setDrawerEditMode(true);
    setShowPetServiceDrawer(true);
    // DON'T remove from list - keep it visible and handle updates properly
  };

  // Handler for deleting boarding from list
  const handleDeleteBoardingFromList = (index) => {
    setBoardingList((prev) => {
      const updatedList = prev.filter((_, i) => i !== index);
      fetchDiscountData([...appointmentList, ...updatedList]);
      return updatedList; // call your function here
    });
    // setBoardingList((prev) => prev.filter((_, i) => i !== index));
    toast.success("Boarding removed from list!", {
      position: "top-center",
    });
  };

  // Handler for editing vet clinic from list
  const handleEditVetClinicFromList = (vetClinic, index) => {
    // Prepare the vet clinic data for editing with all necessary fields
    const editData = {
      ...vetClinic,
      // Ensure ids are present for downstream drawers
      service_id: vetClinic.service_id,
      pet_id: vetClinic.pet_id,
      vendor_pet_id: vetClinic.pet_id,
      vendor_client_id: clientData?._id,
      service_category_type_id: vetClinic.service_category_type_id,
      service_type_name: "Vet Clinic", // Force service type name for category matching
      service_type_id: vetClinic.service_type_id,
      // Ensure dates are properly formatted for editing
      start_date: vetClinic.appointment_date || getStartDateValue(vetClinic),
      start_time: vetClinic.appointment_time || vetClinic.start_time,
      appointment_date: vetClinic.appointment_date || getStartDateValue(vetClinic),
      appointment_time: vetClinic.appointment_time || vetClinic.start_time,
      // Veterinarian details
      veterinarian_id: vetClinic.veterinarian_id || vetClinic.technician_id,
      veterinarian_name: vetClinic.veterinarian_name || vetClinic.employee_name,
      technician_id: vetClinic.veterinarian_id || vetClinic.technician_id,
      employee_name: vetClinic.veterinarian_name || vetClinic.employee_name,
      // Pricing details
      price: vetClinic.unit_price,
      discount: vetClinic.discount || 0,
      gst: vetClinic.gst || 0,
      total_price: vetClinic.total_price,
      // Pet details
      pet_name: vetClinic.pet_name,
      pet_type: vetClinic.pet_type,
      pet_size: getPetSizeValue(vetClinic),
      pet_breed: vetClinic.pet_breed,
      // Store the original index and vet clinic data for restoration
      _editIndex: index,
      _originalVetClinic: { ...vetClinic },
    };

    setItemData(editData);
    // setDrawerEditMode(true);
    setShowPetServiceDrawer(true);
    // DON'T remove from list - keep it visible and handle updates properly
  };

  // Handler for deleting vet clinic from list
  const handleDeleteVetClinicFromList = (index) => {
    setVetClinicList((prev) => prev.filter((_, i) => i !== index));
    toast.success("Vet clinic appointment removed from list!", {
      position: "top-center",
    });
  };

  // Calculate total GST including addon GST for enquiry (for totals section)
  const calculateTotalGSTWithAddons = (enquiry) => {
    if (!enquiry || !enquiry.items) return 0;

    // GST on main service items
    const mainServiceGST =
      (parseFloat(enquiry.sub_total_amount || 0) *
        parseFloat(enquiry.total_gst || 0)) /
      100;

    // GST on addons
    let addonGST = 0;
    enquiry.items.forEach((item) => {
      if (item.addons && item.addons.length > 0) {
        item.addons.forEach((addon) => {
          const addonBasePrice = parseFloat(addon.addon_price || 0);
          const itemGSTRate = parseFloat(item.gst || 0);
          addonGST += parseFloat((addonBasePrice * itemGSTRate) / 100);
        });
      }
    });

    const totalGST = mainServiceGST + addonGST;
    return totalGST;
  };

  // API call for booking
  const handleBookingAPI = async (bookingType, paymentData = null) => {
    // Prevent multiple calls
    if (isBookingLoading) {
      return;
    }

    const totalItems =
      appointmentList.length +
      boardingList.length +
      vetClinicList.length +
      productList.length;

    if (totalItems === 0) {
      toast.warn("No items to save!", {
        position: "top-center",
      });
      return;
    }

    setIsBookingLoading(true);

    try {
      const totals = totalSummary;

      // Prepare appointment items (including daycare)
      const appointmentItems = appointmentList.map((appointment) => {
        const activeDiscount = appointment?.discounts?.find(
          (d) => d.is_active === 1
        );
        const updatedTotalPrice = Math.max(0, Number(appointment.unit_price || appointment.total_price || appointment.price || 0) - Number(activeDiscount?.discount_amount || appointment?.discount_amount || appointment?.discount || 0));
        let updatedGstAmount = appointment.gst;
        if (
          updatedTotalPrice <
          appointment.total_price - (appointment.gst || 0)
        ) {
          updatedGstAmount =
            updatedTotalPrice * (appointment.tax_percentage / 100);
        }
        const item = {
          item_type: appointment.item_type || "grooming", // This preserves 'day_care' for daycare items
          service_category_type_id: appointment.service_category_type_id,
          vendor_pet_id: appointment.pet_id || appointment.vendor_pet_id,
          service_id: appointment.service_id, // This should include the service_id from vendordaycareservice
          technician_id: appointment.technician_id,
          start_date: getStartDateValue(appointment),
          start_time: appointment.start_time,
          duration: appointment.duration,
          frequency: appointment.frequency,
          number_of_times: appointment.numberOfTimes,
          quantity: 1,
          unit_price: parseFloat(
            appointment.basic_price || appointment.unit_price || 0
          ),
          discount: parseFloat(appointment.discount || 0),
          discounts: appointment?.discounts || [],
          gst: parseFloat(updatedGstAmount || 0),
          total_price: parseFloat(updatedTotalPrice || 0),
          addons: appointment.addons || [],
          notes: appointment.notes || "",
          tax_percentage: appointment.tax_percentage || 0,
          price_surcharge: appointment.price_surcharge || [],

          amount_after_discount: appointment?.amount_after_discount,
          tax_amount: appointment?.tax_amount,
          amount_with_tax: appointment?.amount_with_tax,
          amount_without_tax: appointment?.amount_without_tax,
          discount_type: appointment?.discount_type,
          discount_amount: appointment?.discount_amount,
          discount_value: appointment?.discount_value,
          discount_name: appointment?.discount_name,
        };

        return item;
      });

      // Prepare boarding items
      const boardingItems = boardingList.map((boarding) => {
        const item = {
          item_type: boarding.item_type || "boarding",
          service_category_type_id: boarding.service_category_type_id,
          vendor_pet_id: boarding.pet_id || boarding.vendor_pet_id,
          service_id: boarding.service_id,
          room_type_id: getRoomTypeIdValue(boarding),
          room_id: getRoomIdValue(boarding),
          room_number: getRoomNumberValue(boarding),
          start_date: getStartDateValue(boarding),
          end_date: getEndDateValue(boarding),
          duration: boarding.duration,
          quantity: boarding.duration,
          unit_price: parseFloat(boarding.unit_price || boarding.basic_price || 0),
          discount: parseFloat(boarding.discount || 0),
          discounts: boarding?.discounts || [],
          gst: parseFloat(boarding.gst || 0),
          total_price: parseFloat(boarding.total_price || 0),
          addons: boarding.addons || [],
          notes: boarding.notes || "",
          tax_percentage: boarding.tax_percentage || 0,
          price_surcharge: boarding.price_surcharge || [],

          amount_after_discount: boarding?.amount_after_discount,
          tax_amount: boarding?.tax_amount,
          amount_with_tax: boarding?.amount_with_tax,
          amount_without_tax: boarding?.amount_without_tax,
          discount_type: boarding?.discount_type,
          discount_amount: boarding?.discount_amount,
          discount_value: boarding?.discount_value,
          discount_name: boarding?.discount_name,
        };

        return item;
      });

      // Prepare vet clinic items
      const vetClinicItems = vetClinicList.map((vetClinic) => ({
        item_type: "vet_clinic",
        vendor_pet_id: vetClinic.pet_id || vetClinic.vendor_pet_id,
        service_id: vetClinic.service_id,
        technician_id:
          vetClinic.veterinarian_id ||
          vetClinic.technician_id ||
          vetClinic.appointment_to,
        start_date: vetClinic.appointment_date || getStartDateValue(vetClinic),
        start_time:
          vetClinic.appointment_start_time ||
          vetClinic.appointment_time ||
          vetClinic.start_time,
        duration: vetClinic.duration,
        quantity: 1,
        unit_price:
          parseFloat(vetClinic.basic_price || vetClinic.unit_price) || 0,
        discount: parseFloat(vetClinic.discount || 0),
        gst: parseFloat(vetClinic.gst || 0),
        total_price: parseFloat(
          vetClinic.total_price || vetClinic.totalAmount || 0
        ),
        addons: vetClinic.addons || [],
        notes: vetClinic.symptoms || vetClinic.notes || "",
        vet_details: {
          symptoms: vetClinic.symptoms || "",
        },
        tax_percentage: vetClinic.tax_percentage || 0,
        amount_after_discount: vetClinic?.amount_after_discount,
        tax_amount: vetClinic?.tax_amount,
        amount_with_tax: vetClinic?.amount_with_tax,
        amount_without_tax: vetClinic?.amount_without_tax,
        discount_type: vetClinic?.discount_type,
        discount_amount: vetClinic?.discount_amount,
        discount_value: vetClinic?.discount_value,
        discount_name: vetClinic?.discount_name,
      }));

      // Prepare products
      const productItems = productList
        .map((product) => {
          // Safely handle product object and its properties
          if (!product) return null;

          const unitPrice = parseFloat(product.unit_price || 0);
          const quantity = parseFloat(product.quantity || 0);
          const discount = parseFloat(product.discount || 0);
          const totalPrice = parseFloat(product.total_price || 0);
          const gst = parseFloat(product.gst || 0);

          // Calculate total price safely
          const calculatedTotalPrice =
            totalPrice || unitPrice * quantity - discount;

          return {
            item_type: "product",
            vendor_pet_id: product.vendor_pet_id || product.pet_id || "",
            service_id: product.service_id || product.product_id || product._id,
            description: product.description || "",
            sku_number: (product.sku_number || product.sku || "")
              .toString()
              .trim(),
            quantity: quantity,
            unit_price: unitPrice,
            discount: discount,
            gst: gst,
            total_price: calculatedTotalPrice,
            notes: product.notes || "",
            tax_percentage: product.gst || 0,
          };
        })
        .filter(Boolean); // Remove any null entries

      // Combine all items
      const orderItems = [
        ...appointmentItems,
        ...boardingItems,
        ...vetClinicItems,
        ...productItems,
      ];

      // Base payload
      const payload = {
        booking_type: bookingType, // 1 - "enquiry", 2 - "booking", 3 - "booking & payment"
        vendor_client_id: clientData._id,
        order_items: orderItems,
        amount_before_discount: parseFloat(totals.subtotal),
        total_amount: parseFloat(totals.total), // Add calculated total for consistency
        // Note: If backend is still calculating differently, this field should override backend calculation
        discount_type: discount.type,
        discount_value: discount.value,
        discount_amount: discount.amount,
        amount_after_discount: totals.total,
        gst_after_discount: totals.gst,
        notes,
      };

      // Add payment details if booking with payment
      if (bookingType === 3 && paymentData) {
        // if (paymentMethods.length > 0) {
        //   // Multiple payment methods
        //   const totalPaid = paymentMethods.reduce(
        //     (sum, pm) => sum + parseFloat(pm.amount || 0),
        //     0
        //   );
        //   payload.paid_amount = totalPaid;
        //   payload.payment_mode = paymentMethods
        //     .map((pm) => pm.method)
        //     .join(", ");
        //   payload.reference_number = paymentMethods
        //     .map((pm) => pm.reference)
        //     .join(", ");

        //   // Calculate payment status for multiple payment methods
        //   const totalAmount = parseFloat(totals.total);
        //   let paymentStatus = "unpaid";
        //   if (totalPaid >= totalAmount) {
        //     paymentStatus = "paid";
        //   } else if (totalPaid > 0) {
        //     paymentStatus = "partial";
        //   }
        //   payload.payment_status = paymentStatus;
        // } else {
        const finalTotalAmount = parseFloat(totals.total);
        const paidAmount = Number(paymentData.amount || finalTotalAmount);
        const waivedAmount = Number(paymentData.waived_amount || 0); // ✅ ADDED

        // Calculate round-off if needed
        const hasDecimal = finalTotalAmount % 1 !== 0;
        let roundOff = null;
        let roundedTotalAmount = finalTotalAmount;

        if (hasDecimal) {
          roundedTotalAmount = Math.round(finalTotalAmount);
          const roundOffDifference = roundedTotalAmount - finalTotalAmount;
          roundOff = roundOffDifference;
        }

        // ✅ UPDATED: Include waived amount in total paid for status calculation
        const totalPaidIncludingWaived = paidAmount + waivedAmount;

        // ✅ UPDATED: Determine payment status considering waived amount
        let paymentStatus = "unpaid";
        if (totalPaidIncludingWaived >= roundedTotalAmount) {
          paymentStatus = "paid";
        } else if (totalPaidIncludingWaived > 0) {
          paymentStatus = "partial";
        }
        // Single payment method
        const paymentAmount = parseFloat(paymentData.amount);
        payload.paid_amount = paymentAmount;
        payload.payment_mode = paymentData.method;
        payload.reference_number = paymentData.reference || "";
        payload.payment_status = paymentStatus;
        payload.waived_amount = waivedAmount; // ✅ INCLUDED
        payload.round_off = roundOff || 0; // ✅ INCLUDED
        // }
      }

      const response = await httpService.post(
        "/vendorappointment/addBooking",
        payload
      );

      if (response.status) {
        let message = "";
        switch (bookingType) {
          case 1:
            message = "Enquiry saved successfully!";
            break;
          case 2:
            message = "Booking saved successfully!";
            break;
          case 3:
            message = "Booking saved and payment processed successfully!";
            break;
          default:
            message = "Request processed successfully!";
        }

        toast.success(message, {
          position: "top-center",
        });
        if (bookingType === 2 || bookingType === 3) {
          await httpService.delete(
            `/vendororderenquiry/deleteOrderEnquiry/${enquiryDetails?._id}`
          );
        }

        if (onSave) {
          onSave(response.data);
        }

        // Refresh orders list after successful booking
        if (window.refreshOrderData) {
          window.refreshOrderData();
        } else if (window.refreshOrdersList) {
          window.refreshOrdersList();
        }

        // Only close drawer for non-payment bookings
        if (bookingType !== 3) {
          handleClose();
        }
      }
    } catch (error) {
      console.error("Error processing booking:", error);

      // ✅ Show specific backend validation messages (e.g., past date)
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        null;
      const isPastDateError =
        error?.response?.data?.code === "PAST_DATE_VALIDATION_ERROR" ||
        (backendMessage &&
          backendMessage.toLowerCase().includes("past date"));

      if (isPastDateError) {
        toast.error(
          backendMessage ||
            "Cannot schedule service for a past date. Please update the date.",
          {
            position: "top-center",
            autoClose: 7000,
          }
        );
      } else if (backendMessage) {
        toast.error(backendMessage, {
          position: "top-center",
          autoClose: 5000,
        });
      } else {
        toast.error("Failed to process request. Please try again", {
          position: "top-center",
        });
      }
    } finally {
      setIsBookingLoading(false);
    }
  };

  // Handler for Save Booking
  const handleSaveBooking = () => {
    if (isBookingLoading) return;
    handleBookingAPI(2);
  };

  // Handler for Save & Add Payment
  const handleSaveAndAddPayment = () => {
    if (isBookingLoading) return;
    if (
      appointmentList.length === 0 &&
      boardingList.length === 0 &&
      vetClinicList.length === 0 &&
      productList.length === 0
    ) {
      toast.warn("No items to save!", {
        position: "top-center",
      });
      return;
    }
    setShowPaymentSection(true);
  };

  // Handler for payment modal completion
    const handleOrderSaveAndPay = async (paymentData) => {
      setIsPaymentLoading(true);
      try {
        // Single payment method validation
        if (!paymentData.method || !paymentData.amount) {
          toast.error("Please fill all payment details", {
            position: "top-center",
          });
          return;
        }
  
        if (paymentData.method !== "cash" && !paymentData.reference) {
          toast.error("Reference number is required for non-cash payments", {
            position: "top-center",
          });
          return;
        }
  
        const totalAmount = parseFloat(totalSummary.total);
        if (paymentData.amount > totalAmount) {
          toast.error("Payment amount cannot exceed the bill amount", {
            position: "top-center",
          });
          return;
        }
        await handleBookingAPI(3, paymentData);
        handleClose();
      } catch (error) {
        console.error("Error processing payment:", error);
        toast.error("Failed to process payment. Please try again", {
          position: "top-center",
        });
      } finally {
        setIsPaymentLoading(false);
      }
    };
    

  // Handler for back button in payment section
  const handleBackFromPayment = () => {
    setShowPaymentSection(false);
    setPaymentDetails({
      paymentType: "",
      amount: "",
      method: "",
      reference: "",
      notes: "",
    });
    setIsPaymentLoading(false); // Reset loading state as well
  };

  // Handle product quantity change in enquiry (exact same logic as BookingDetailsDrawer)
  const handleProductQuantityChanges = (item, delta, enquiry) => {
    // Use quantity_available if available, otherwise use original_quantity_available as fallback
    // original_quantity_available preserves the original limit from API response
    const availableQuantity =
      item.quantity_available ||
      item.product_details?.quantity_available ||
      item.original_quantity_available ||
      999;
    const currentQuantity = item.quantity || 1;
    const newQuantity = currentQuantity + delta;

    // If quantity drops to zero or below, don't allow
    if (newQuantity <= 0) {
      toast.warn("Quantity cannot be less than 1", {
        position: "top-center",
      });
      return;
    }

    // Update the enquiry data (same pattern as BookingDetailsDrawer)
    setEnquiryData((prev) =>
      prev.map((e) => {
        if (e._id === enquiry._id) {
          return {
            ...e,
            items: e.items.map((i) => {
              if (i._id === item._id) {
                let finalQuantity = newQuantity;
                let finalTotalPrice =
                  parseFloat(i.price || i.unit_price || 0) * newQuantity;

                // If quantity exceeds available, set to available quantity (same as BookingDetailsDrawer)
                if (newQuantity > availableQuantity) {
                  toast.warn(`Only ${availableQuantity} items available`);
                  finalQuantity = availableQuantity;
                  finalTotalPrice =
                    parseFloat(i.price || i.unit_price || 0) *
                    availableQuantity;
                }

                return {
                  ...i,
                  quantity: finalQuantity,
                  total_price: finalTotalPrice,
                };
              }
              return i;
            }),
          };
        }
        return e;
      })
    );
  };

  // Handle product quantity input in enquiry (like in BookingDetailsDrawer)
  const handleProductQuantityInputs = (item, value, enquiry) => {
    let qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
    }

    // Use quantity_available if available, otherwise use original_quantity_available as fallback
    // original_quantity_available preserves the original limit from API response
    const maxQuantity =
      item.quantity_available ||
      item.product_details?.quantity_available ||
      item.original_quantity_available ||
      999;
    if (qty > maxQuantity) {
      toast.warn(`Only ${maxQuantity} items available`, {
        position: "top-center",
      });
      qty = maxQuantity;
    }

    // Update the enquiry data with new quantity
    setEnquiryData((prev) =>
      prev.map((e) => {
        if (e._id === enquiry._id) {
          return {
            ...e,
            items: e.items.map((i) => {
              if (i._id === item._id) {
                const updatedItem = {
                  ...i,
                  quantity: qty,
                  total_price: parseFloat(i.price || i.unit_price || 0) * qty,
                };
                return updatedItem;
              }
              return i;
            }),
          };
        }
        return e;
      })
    );
  };

  const formatName = (name = "") =>
    name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <>
      {isAddonsDrawerOpen ? (
        <SelectAddOnsDrawer
          isOpen={isAddonsDrawerOpen}
          onClose={handleCloseAddons}
          onSave={handleSaveAddons} // if your drawer supports saving
          serviceCategoryId={addonsServiceCategoryId}
          petType={addonsPetType}
          selectedAddons={selectedAddons}
          serviceTypeName={serviceTypeName}
        />
      ) : showAddNewPet ? (
        <AddNewPet
          isOpen={showAddNewPet}
          onClose={() => setShowAddNewPet(false)}
          onSave={handlePetSaved}
          onBack={handleAddNewPetBack}
          clientId={clientData?._id}
        />
      ) : showHistoryDrawer ? (
        <CombinedHistoryDrawer
          isOpen={showHistoryDrawer}
          onClose={() => setShowHistoryDrawer(false)}
          clientId={clientData?._id}
          clientData={clientData}
          onReorder={(item) => {
            // Keep your exact reorder behaviour (same as before)
            const editData = {
              ...item,
              service_id: item.service_id,
              vendor_pet_id: item.vendor_pet_id || item.pet_id,
              pet_id: item.vendor_pet_id || item.pet_id,
              // If boarding-like item, force boarding type:
              item_type:
                item.item_type === "boarding"
                  ? "boarding"
                  : item.item_type || "grooming",
              service_type_name:
                item.service_type_name ||
                item.service_name ||
                (item.item_type === "boarding" ? "Boarding" : item.item_type),
              // Pass category id hints for matching
              service_category_type_id:
                item.service_category_type_id || item.service_type_id,
              service_type_id:
                item.service_type_id || item.service_category_type_id,
            };

            // Close history before opening drawer to avoid overlay/back issues
            setShowHistoryDrawer(false);
            setTimeout(() => {
              setItemData({ ...editData, _fromHistoryReorder: true });
              // setDrawerEditMode(true);
              setShowPetServiceDrawer(true);
            }, 0);
          }}
        />
      ) : !showPetServiceDrawer ? (
        <div
          className={`fixed inset-0 z-50 transition-all duration-300 ease-in-out ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <div
            className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-[2px]"
            onClick={handleClose}
          />
          <div
            className={`absolute right-0 top-0 h-full w-full lg:w-1/2 bg-white shadow-xl transform transition-transform duration-300 ease-out ${
              isOpen ? "translate-x-0" : "translate-x-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modern Header */}
            <div className="flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex justify-start items-center p-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50 shadow-sm gap-3">
                <button
                  onClick={handleClose}
                  className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-white/70 transition-colors duration-200"
                >
                  <HiArrowSmLeft className="w-6 h-6 text-gray-700" />
                </button>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                    <FiCalendar className="w-4 h-4 text-white" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-800">
                    Enquiry
                  </h2>
                </div>
              </div>
              <div className="flex flex-col justify-center gap-1 pr-4">
                <span className="text-xl font-semibold text-gray-800">
                  {enquiryData?.order_number}
                </span>
                <span className="text-lg text-gray-800">
                  {enquiryData?.createdAt &&
                    format(
                      new Date(enquiryData?.createdAt),
                      "dd-MM-yyyy hh:mm a"
                    )}
                </span>
              </div>
            </div>

            {/* Content */}
            {isOpen && (
              <div className="relative flex h-[calc(100vh-73px)] flex-col">
                <div className="p-6 space-y-6 overflow-auto bg-gradient-to-b from-gray-50 to-white flex-1">
                  <div className="transition-opacity duration-200">

                    {/* Client Search Section */}
                    <div className="mb-6">
                      {/* Loading and Error States */}
                      {loading && (
                        <div className="mt-4 flex items-center gap-3 p-4 bg-blue-50 rounded-xl">
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500"></div>
                          <p className="text-sm text-blue-700">
                            Searching for client...
                          </p>
                        </div>
                      )}
                      {error && (
                        <div className="mt-4 flex items-center gap-3 p-4 bg-red-50 rounded-xl">
                          <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs">!</span>
                          </div>
                          <p className="text-sm text-red-700">{error}</p>
                        </div>
                      )}

                      {/* Client Data Display - Improved Spacing */}
                      {clientData && (
                        <>
                          <div className="relative p-5 bg-white rounded-xl border border-gray-200 shadow-sm">
                            <div className="absolute top-3 right-3 flex gap-2">
                              <button
                                onClick={() => setShowHistoryDrawer(true)}
                                className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-500 text-white text-xs font-medium rounded-lg hover:bg-blue-600 transition-all duration-200"
                              >
                                <MdHistory className="w-3 h-3" />
                                Recent Visits
                              </button>
                              <button
                                onClick={() => {
                                  setClientData(null);
                                  setError(null);
                                  setAppointmentList([]);
                                }}
                                className="inline-flex items-center justify-center w-8 h-8 bg-gray-200 text-gray-600 text-xs font-medium rounded-full hover:bg-gray-300 transition-all duration-200"
                                title="Remove client and go back to search"
                              >
                                <FiX className="w-3 h-3" />
                              </button>
                            </div>

                            <div className="space-y-3">
                              {/* Client Info */}
                              <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center">
                                  <FiUser className="w-6 h-6 text-white" />
                                </div>
                                <div className="flex-1">
                                  <h3 className="text-lg font-semibold text-gray-800 mb-1">
                                    {clientData.firstname} {clientData.lastname}
                                  </h3>
                                  <div className="flex items-center gap-4 text-sm text-gray-500">
                                    <span className="flex items-center gap-1">
                                      <FiPhone className="w-3 h-3" />
                                      {clientData.phone}
                                    </span>
                                    {clientData.email && (
                                      <span className="flex items-center gap-1">
                                        <FiMail className="w-3 h-3" />
                                        {clientData.email}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Address */}
                              {clientData.address?.address1 && (
                                <div className="flex items-center gap-2 text-sm text-gray-600 pl-16">
                                  <FiMapPin className="w-3 h-3" />
                                  <span>
                                    {[
                                      clientData.address.address1,
                                      clientData.address.city,
                                      clientData.address.state,
                                      clientData.address.zip,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </span>
                                  <button
                                    onClick={() => {
                                      const addressString = [
                                        clientData.address.address1,
                                        clientData.address.city,
                                        clientData.address.state,
                                        clientData.address.zip,
                                      ]
                                        .filter(Boolean)
                                        .join(", ");

                                      const destination =
                                        clientData.address?.latitude &&
                                        clientData.address?.longitude
                                          ? `${clientData.address.latitude},${clientData.address.longitude}`
                                          : encodeURIComponent(addressString);

                                      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;

                                      Swal.fire({
                                        title: "Get Directions",
                                        text: "Do you want to open Google Maps for directions?",
                                        icon: "question",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes",
                                        cancelButtonText: "No",
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          window.open(googleMapsUrl, "_blank");
                                        }
                                      });
                                    }}
                                    className="inline-flex items-center gap-1 px-3 py-2 text-sm font-medium bg-orange-100 text-orange-600 rounded-lg hover:bg-orange-200 transition-all duration-200 shadow hover:shadow-md flex-shrink-0"
                                    title="Get Directions"
                                  >
                                    <FaDirections className="w-3 h-3" />
                                    Directions
                                  </button>
                                </div>
                              )}

                              {/* Labels */}
                              {clientData.labels &&
                                clientData.labels.length > 0 &&
                                clientData.labels.some(
                                  (label) => label && label.trim() !== ""
                                ) && (
                                  <div className="flex items-center gap-2 pl-16">
                                    <div className="flex flex-wrap gap-2">
                                      {clientData.labels.map(
                                        (labelString, index) => {
                                          const individualLabels = labelString
                                            .split(",")
                                            .map((label) => label.trim());
                                          return individualLabels.map(
                                            (label, labelIndex) => {
                                              if (!label) return null;
                                              return (
                                                <span
                                                  key={`${index}-${labelIndex}`}
                                                  className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700"
                                                >
                                                  {label}
                                                </span>
                                              );
                                            }
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                )}
                              {clientData.pets &&
                                clientData.pets.length > 0 && (
                                  <div className="mt-2 text-sm text-gray-700">
                                    <div className="flex items-center gap-2">
                                      <div className="flex-1 min-w-0">
                                        <div className="inline-flex flex-wrap items-center gap-1 text-sm leading-none">
                                          {clientData.pets.map((pet, idx) => {
                                            const size = pet.size_details?.size_label?.charAt(0)?.toUpperCase() || null;
                                            const details = size
                                              ? `${size}`
                                              : null;

                                            // Title can also just show name and size
                                            const titleParts = [
                                              pet.name,
                                              size,
                                            ].filter(Boolean);
                                            const title = titleParts.join(", ");

                                            // Determine icon based on pet type
                                            let PetIcon = FaPaw;
                                            if (
                                              pet.pet_type_details?.name ===
                                              "Dog"
                                            )
                                              PetIcon = FaDog;
                                            else if (
                                              pet.pet_type_details?.name ===
                                              "Cat"
                                            )
                                              PetIcon = FaCat;

                                            return (
                                              <span
                                                key={pet._id ?? idx}
                                                className="inline-flex items-center gap-1 text-gray-700"
                                                title={title}
                                                aria-label={`Pet ${pet.name}`}
                                              >
                                                <PetIcon
                                                  className="w-3 h-3"
                                                  aria-hidden="true"
                                                />
                                                <strong className="text-gray-800 truncate max-w-[12rem]">
                                                  {pet.name}
                                                </strong>
                                                {details && (
                                                  <span className="text-gray-500">
                                                    ({details})
                                                  </span>
                                                )}
                                                {idx !==
                                                  clientData.pets.length -
                                                    1 && (
                                                  <span
                                                    className="mx-1 text-gray-300"
                                                    aria-hidden="true"
                                                  >
                                                    ,
                                                  </span>
                                                )}
                                              </span>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* Service List Display - Appointments, Boarding, and Vet Clinic */}
                          {(appointmentList.length > 0 ||
                            boardingList.length > 0 ||
                            vetClinicList.length > 0 ||
                            productList.length > 0) && (
                            <div className="mt-6 space-y-4">
                              {appointmentList?.map((appointment, index) => {
                                const appointmentDate = safeFormatDate(
                                  getStartDateValue(appointment)
                                );
                                const addonsExists =
                                  appointment.addons.length > 0;
                                return (
                                  <div
                                    key={appointment.id}
                                    className="bg-white rounded-lg border border-gray-200 shadow-sm"
                                  >
                                    {/* Date Header */}
                                    <div className="px-4 py-3">
                                      <div className="flex items-center justify-between mb-4">
                                        <h3 className="text-sm font-semibold text-gray-900">
                                          {
                                            appointment?.service_type_name ||
                                              "Date not selected"
                                            // appointmentDate ? appointmentDate.toLocaleDateString(
                                            //     "en-IN",
                                            //     {
                                            //         weekday: "long",
                                            //         month: "short",
                                            //         day: "numeric",
                                            //         year: "numeric",
                                            //     }
                                            // ) : "Date not selected"
                                          }
                                        </h3>
                                        <div className="flex items-center gap-2">
                                          <button
                                            onClick={() => {
                                              setIsServiceEditMode(true);
                                              handleEditAppointmentFromList(
                                                appointment,
                                                index
                                              );
                                            }}
                                            className="w-6 h-6 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                            title="Edit"
                                          >
                                            <FiEdit3 className="w-3 h-3 text-gray-600" />
                                          </button>
                                          <button
                                            onClick={() =>
                                              handleDeleteAppointmentFromList(
                                                index
                                              )
                                            }
                                            className="w-6 h-6 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                            title="Delete"
                                          >
                                            <FiX className="w-3 h-3 text-gray-600" />
                                          </button>
                                        </div>
                                      </div>

                                      {/* Pet and Service Info */}
                                      <div
                                        className={`flex items-start gap-3 ${
                                          addonsExists ? "mb-3" : ""
                                        }`}
                                      >
                                        <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                          <MdPets className="w-4 h-4 text-orange-600" />
                                        </div>
                                        <div className="flex-1">
                                          <div className="flex items-center gap-2 mb-1">
                                            <span className="font-semibold text-gray-900 inline-flex items-center gap-1">
                                              {appointment.pet_name && (
                                                <FaDog className="w-3.5 h-3.5 text-orange-500" />
                                              )}
                                              {appointment.pet_name}
                                            </span>
                                            {appointment.pet_breed && (
                                              <>
                                                <span className="text-gray-400">
                                                  •
                                                </span>
                                                <span className="text-sm text-gray-600 inline-flex items-center gap-1">
                                                  <FaPaw className="w-3 h-3 text-purple-500" />
                                                  {appointment.pet_breed}
                                                </span>
                                              </>
                                            )}
                                            {getPetSizeValue(appointment) && (
                                              <>
                                                <span className="text-gray-400">
                                                  •
                                                </span>
                                                <span className="text-sm text-gray-600 inline-flex items-center gap-1">
                                                  {getPetSizeValue(appointment)}
                                                </span>
                                              </>
                                            )}
                                          </div>

                                          {/* Main Service */}
                                          <div className="flex items-center justify-between">
                                            <span className="text-gray-900 font-medium">
                                              {appointment.service_name}
                                            </span>
                                            <div className="flex flex-col">
                                              {PriceWithDiscount(appointment)}
                                            </div>
                                          </div>
                                          <p className="text-sm text-gray-500 mt-1">
                                            {appointmentDate && (
                                              <span className="inline-flex items-center gap-1">
                                                <FaCalendar className="w-3.5 h-3.5 text-green-500" />
                                                {appointmentDate.toLocaleDateString(
                                                  "en-IN",
                                                  {
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                  }
                                                )}
                                              </span>
                                            )}
                                            {appointmentDate &&
                                              appointment.start_time &&
                                              " � "}
                                            {appointment.start_time && (
                                              <span className="inline-flex items-center gap-1">
                                                <FaClock className="w-3.5 h-3.5 text-blue-500" />
                                                {appointment.start_time}
                                              </span>
                                            )}
                                            {appointment.start_time &&
                                              appointment.duration &&
                                              " • "}
                                            {appointment.duration}
                                            {appointment.duration &&
                                              appointment.employee_name &&
                                              " • "}
                                            {appointment.employee_name && (
                                              <span className="inline-flex items-center gap-1">
                                                <FaUserTie className="w-3.5 h-3.5 text-purple-500" />
                                                {appointment.employee_name}
                                              </span>
                                            )}
                                          </p>
                                          {/* Frequency and Number of Times for Dog Walking and Daycare */}
                                          {appointment.frequency &&
                                            (appointment.numberOfTimes ||
                                              appointment.item_type ===
                                                "day_care" ||
                                              appointment.item_type ===
                                                "daycare") && (
                                              <div className="flex items-center gap-4 mt-2">
                                                <div className="flex items-center gap-1">
                                                  <FaCalendar className="w-3.5 h-3.5 text-purple-500" />
                                                  <span className="text-xs text-gray-600 font-medium">
                                                    Frequency:{" "}
                                                    {appointment.frequency ===
                                                    "one_time"
                                                      ? "One Time"
                                                      : appointment.frequency ===
                                                        "weekly"
                                                      ? "Weekly"
                                                      : appointment.frequency ===
                                                        "monthly"
                                                      ? "Monthly"
                                                      : appointment.frequency ===
                                                        "quaterly"
                                                      ? "Quarterly"
                                                      : appointment.frequency}
                                                  </span>
                                                </div>
                                                {appointment.numberOfTimes && (
                                                  <div className="flex items-center gap-1">
                                                    <FaSortNumericUp className="w-3.5 h-3.5 text-orange-500" />
                                                    <span className="text-xs text-gray-600 font-medium">
                                                      Number of Times:{" "}
                                                      {appointment.numberOfTimes ===
                                                      "once"
                                                        ? "Once"
                                                        : appointment.numberOfTimes ===
                                                          "twice"
                                                        ? "Twice"
                                                        : appointment.numberOfTimes}
                                                    </span>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                        </div>
                                      </div>

                                      {/* Add-ons */}
                                      {appointment.addons &&
                                        appointment.addons.length > 0 &&
                                        appointment.addons.map(
                                          (addon, addonIndex) => (
                                            <div
                                              key={addonIndex}
                                              className="flex items-start gap-3"
                                            >
                                              <AddonIcon />
                                              <div className="flex-1">
                                                <div className="flex items-center justify-between">
                                                  <div className="flex items-center gap-2">
                                                    <span className="text-gray-900 font-medium">
                                                      {addon.name}
                                                    </span>
                                                  </div>
                                                  <div className="flex items-center gap-2">
                                                    <span className="text-green-600 font-bold">
                                                      ₹ {addon.addon_price}
                                                    </span>
                                                    <button
                                                      onClick={() => {
                                                        const updatedAppointments =
                                                          [...appointmentList];
                                                        updatedAppointments[
                                                          index
                                                        ].addons =
                                                          updatedAppointments[
                                                            index
                                                          ].addons.filter(
                                                            (_, i) =>
                                                              i !== addonIndex
                                                          );
                                                        setAppointmentList(
                                                          updatedAppointments
                                                        );
                                                      }}
                                                      className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                      title="Remove"
                                                    >
                                                      <FiX className="w-4 h-4 text-red-600" />
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      {/* Addons Section Button */}
                                      <div className="flex justify-end p-1 border-gray-100">
                                        <button
                                          onClick={() =>
                                            handleOpenAddonsDrawer(
                                              appointment,
                                              index,
                                              "appointmentList"
                                            )
                                          }
                                          className="px-3 py-1.5 text-sm font-semibold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 rounded-lg transition-all duration-200"
                                        >
                                          + Addons
                                        </button>
                                      </div>

                                      {/* Products */}
                                      {appointment.products &&
                                        appointment.products.length > 0 && (
                                          <div>
                                            <h4 className="text-sm font-semibold text-gray-700 mb-2">
                                              Products
                                            </h4>
                                            {appointment.products.map(
                                              (product, productIndex) => (
                                                <div
                                                  key={productIndex}
                                                  className="flex items-start gap-3 mb-3"
                                                >
                                                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                                    <MdShoppingCart className="w-4 h-4 text-green-600" />
                                                  </div>
                                                  <div className="flex-1">
                                                    <div className="flex items-center justify-between">
                                                      <div className="flex items-center gap-2">
                                                        <span className="text-gray-900 font-medium">
                                                          {product.name}
                                                        </span>
                                                        <span className="text-sm text-gray-500">
                                                          (
                                                          {product.quantity ||
                                                            2}
                                                          )
                                                        </span>
                                                      </div>
                                                      <div className="flex items-center gap-2">
                                                        <span className="text-green-600 font-bold">
                                                          ₹ {product.price}
                                                        </span>
                                                        <button
                                                          onClick={() => {
                                                            const updatedAppointments =
                                                              [
                                                                ...appointmentList,
                                                              ];
                                                            updatedAppointments[
                                                              index
                                                            ].products =
                                                              updatedAppointments[
                                                                index
                                                              ].products.filter(
                                                                (_, i) =>
                                                                  i !==
                                                                  productIndex
                                                              );
                                                            setAppointmentList(
                                                              updatedAppointments
                                                            );
                                                          }}
                                                          className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                          title="Remove"
                                                        >
                                                          <FiX className="w-3 h-3 text-gray-600" />
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                );
                              })}
                              {/* Boarding Items */}
                              {boardingList?.map((boarding, index) => {
                                const checkinDate = safeFormatDate(
                                  getStartDateValue(boarding)
                                );
                                const checkoutDate = safeFormatDate(
                                  getEndDateValue(boarding)
                                );
                                const addonsExists = boarding.addons.length > 0;
                                return (
                                  <div
                                    key={`boarding-${index}`}
                                    className="bg-white rounded-lg border border-gray-200 shadow-sm"
                                  >
                                    {/* Date Header */}
                                    <div className="px-4 py-3">
                                      <div className="flex items-center justify-between mb-4">
                                        <h3 className="text-sm font-semibold text-gray-900">
                                          {checkinDate
                                            ? checkinDate.toLocaleDateString(
                                                "en-IN",
                                                {
                                                  weekday: "long",
                                                  month: "short",
                                                  day: "numeric",
                                                  year: "numeric",
                                                }
                                              )
                                            : "Date not selected"}
                                        </h3>
                                      </div>

                                      {/* Pet and Service Info */}
                                      <div
                                        className={`flex items-start gap-3 ${
                                          addonsExists ? "mb-3" : ""
                                        }`}
                                      >
                                        <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                          <MdLocalHotel className="w-4 h-4 text-purple-600" />
                                        </div>
                                        <div className="flex-1">
                                          {/* Header with Date and Actions */}
                                          <div className="flex items-center justify-between mb-1">
                                            <div className="flex items-center gap-2">
                                              <span className="font-semibold text-gray-900">
                                                {boarding.pet_name}
                                              </span>
                                              {boarding.pet_breed && (
                                                <>
                                                  <span className="text-gray-400">
                                                    •
                                                  </span>
                                                  <span className="text-sm text-gray-600">
                                                    {boarding.pet_breed}
                                                  </span>
                                                </>
                                              )}
                                              {getPetSizeValue(boarding) && (
                                                <>
                                                  <span className="text-gray-400">
                                                    •
                                                  </span>
                                                  <span className="text-sm text-gray-600 inline-flex items-center gap-1">
                                                    {getPetSizeValue(boarding)}
                                                  </span>
                                                </>
                                              )}
                                            </div>
                                            <div className="flex items-center gap-2">
                                              <button
                                                onClick={() =>
                                                  handleEditBoardingFromList(
                                                    boarding,
                                                    index
                                                  )
                                                }
                                                className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                title="Edit"
                                              >
                                                <FiEdit3 className="w-3 h-3 text-gray-600" />
                                              </button>
                                              <button
                                                onClick={() =>
                                                  handleDeleteBoardingFromList(
                                                    index
                                                  )
                                                }
                                                className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                title="Delete"
                                              >
                                                <FiX className="w-3 h-3 text-gray-600" />
                                              </button>
                                            </div>
                                          </div>

                                          {/* Main Service */}
                                          <div className="flex items-center justify-between">
                                            <span className="text-gray-900 font-medium">
                                              {getBoardingDisplayText(boarding)}
                                            </span>
                                            <div className="flex flex-col">
                                              {PriceWithDiscount(boarding)}
                                            </div>
                                          </div>

                                          {/* Schedule */}
                                          <div className="mt-1">
                                            <p className="text-sm text-gray-500">
                                              {getBoardingScheduleText(
                                                boarding
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      {/* Add-ons */}
                                      {boarding.addons &&
                                        boarding.addons.length > 0 &&
                                        boarding.addons.map(
                                          (addon, addonIndex) => (
                                            <div
                                              key={addonIndex}
                                              className="flex items-start gap-3 mb-3"
                                            >
                                              <AddonIcon />
                                              <div className="flex-1">
                                                <div className="flex items-center justify-between">
                                                  <div className="flex items-center gap-2">
                                                    <span className="text-gray-900 font-medium">
                                                      {addon.name}
                                                    </span>
                                                  </div>
                                                  <div className="flex items-center gap-2">
                                                    <span className="text-green-600 font-bold">
                                                      ₹ {addon.addon_price}
                                                    </span>
                                                    <button
                                                      onClick={() => {
                                                        const updatedBoarding =
                                                          [...boardingList];
                                                        updatedBoarding[
                                                          index
                                                        ].addons =
                                                          updatedBoarding[
                                                            index
                                                          ].addons.filter(
                                                            (_, i) =>
                                                              i !== addonIndex
                                                          );
                                                        setBoardingList(
                                                          updatedBoarding
                                                        );
                                                      }}
                                                      className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                      title="Remove"
                                                    >
                                                      <FiX className="w-4 h-4 text-red-600" />
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      {/* Addons Section Button */}
                                      <div className="flex justify-end p-1 border-gray-100">
                                        <button
                                          onClick={() =>
                                            handleOpenAddonsDrawer(
                                              boarding,
                                              index,
                                              "boardingList"
                                            )
                                          }
                                          className="px-3 py-1.5 text-sm font-semibold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 rounded-lg transition-all duration-200"
                                        >
                                          + Addons
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                              {/* Vet Clinic Items */}
                              {vetClinicList?.map((vetClinic, index) => {
                                const appointmentDate = safeFormatDate(
                                  vetClinic.appointment_date ||
                                    getStartDateValue(vetClinic)
                                );
                                const addonsExists =
                                  vetClinic.addons.length > 0;
                                return (
                                  <div
                                    key={`vetclinic-${index}`}
                                    className="bg-white rounded-lg border border-gray-200 shadow-sm"
                                  >
                                    {/* Date Header */}
                                    <div className="px-4 py-3">
                                      <div className="flex items-center justify-between mb-4">
                                        <h3 className="text-sm font-semibold text-gray-900">
                                          {appointmentDate
                                            ? appointmentDate.toLocaleDateString(
                                                "en-IN",
                                                {
                                                  weekday: "long",
                                                  month: "short",
                                                  day: "numeric",
                                                  year: "numeric",
                                                }
                                              )
                                            : "Date not selected"}
                                        </h3>
                                      </div>

                                      {/* Pet and Service Info */}
                                      <div
                                        className={`flex items-start gap-3 ${
                                          addonsExists ? "mb-3" : ""
                                        }`}
                                      >
                                        <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                          <MdSpa className="w-4 h-4 text-red-600" />
                                        </div>
                                        <div className="flex-1">
                                          {/* Header with Date and Actions */}
                                          <div className="flex items-center justify-between mb-1">
                                            <div className="flex items-center gap-2">
                                              <span className="font-semibold text-gray-900">
                                                {vetClinic.pet_name}
                                              </span>
                                              {vetClinic.pet_breed && (
                                                <>
                                                  <span className="text-gray-400">
                                                    •
                                                  </span>
                                                  <span className="text-sm text-gray-600">
                                                    {vetClinic.pet_breed}
                                                  </span>
                                                </>
                                              )}
                                              {getPetSizeValue(vetClinic) && (
                                                <>
                                                  <span className="text-gray-400">
                                                    •
                                                  </span>
                                                  <span className="text-sm text-gray-600 inline-flex items-center gap-1">
                                                    {getPetSizeValue(vetClinic)}
                                                  </span>
                                                </>
                                              )}
                                            </div>
                                            <div className="flex items-center gap-2">
                                              <button
                                                onClick={() =>
                                                  handleEditVetClinicFromList(
                                                    vetClinic,
                                                    index
                                                  )
                                                }
                                                className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                title="Edit"
                                              >
                                                <FiEdit3 className="w-3 h-3 text-gray-600" />
                                              </button>
                                              <button
                                                onClick={() =>
                                                  handleDeleteVetClinicFromList(
                                                    index
                                                  )
                                                }
                                                className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                title="Delete"
                                              >
                                                <FiX className="w-3 h-3 text-gray-600" />
                                              </button>
                                            </div>
                                          </div>

                                          {/* Main Service */}
                                          <div className="flex items-center justify-between">
                                            <span className="text-gray-900 font-medium">
                                              Vet Clinic -{" "}
                                              {vetClinic.service_name ||
                                                "Service"}{" "}
                                              -{" "}
                                              {vetClinic.veterinarian_name ||
                                                "Veterinarian"}
                                            </span>
                                            <span className="text-green-600 font-bold">
                                              ₹{" "}
                                              {vetClinic.unit_price ||
                                                vetClinic.total_price}
                                            </span>
                                          </div>

                                          {/* Schedule */}
                                          <div className="mt-1">
                                            <p className="text-sm text-gray-500">
                                              {appointmentDate
                                                ? appointmentDate.toLocaleDateString()
                                                : "Date not selected"}{" "}
                                              •{" "}
                                              {vetClinic.appointment_time ||
                                                vetClinic.start_time ||
                                                "Time not selected"}{" "}
                                              •{" "}
                                              {vetClinic.duration || "Duration"}{" "}
                                              min
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      {vetClinic.addons &&
                                        vetClinic.addons.length > 0 &&
                                        vetClinic.addons.map(
                                          (addon, addonIndex) => (
                                            <div
                                              key={addonIndex}
                                              className="flex items-start gap-3 mb-3"
                                            >
                                              <AddonIcon />
                                              <div className="flex-1">
                                                <div className="flex items-center justify-between">
                                                  <div className="flex items-center gap-2">
                                                    <span className="text-gray-900 font-medium">
                                                      {addon.name}
                                                    </span>
                                                  </div>
                                                  <div className="flex items-center gap-2">
                                                    <span className="text-green-600 font-bold">
                                                      ₹ {addon.addon_price}
                                                    </span>
                                                    <button
                                                      onClick={() => {
                                                        const updatedVetClinic =
                                                          [...vetClinicList];
                                                        updatedVetClinic[
                                                          index
                                                        ].addons =
                                                          updatedVetClinic[
                                                            index
                                                          ].addons.filter(
                                                            (_, i) =>
                                                              i !== addonIndex
                                                          );
                                                        setVetClinicList(
                                                          updatedVetClinic
                                                        );
                                                      }}
                                                      className="w-5 h-5 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                                                      title="Remove"
                                                    >
                                                      <FiX className="w-4 h-4 text-red-600" />
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      {/* Addons Section Button */}
                                      <div className="flex justify-end p-1 border-gray-100">
                                        <button
                                          onClick={() =>
                                            handleOpenAddonsDrawer(
                                              vetClinic,
                                              index,
                                              "vetClinicList"
                                            )
                                          }
                                          className="px-3 py-1.5 text-sm font-semibold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 rounded-lg transition-all duration-200"
                                        >
                                          + Addons
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                              {productList.length > 0 && (
                                <div className="w-full border rounded shadow-sm bg-neutral-50 p-3">
                                  <div className="flex items-center justify-between border-b pb-2">
                                    <h3 className="text-sm font-semibold text-gray-800">
                                      Products
                                    </h3>
                                  </div>

                                  {productList.map((product, idx) => {
                                    // Safely handle product object
                                    if (!product) return null;

                                    return (
                                      <div
                                        key={product.service_id || idx}
                                        className="mt-2 flex items-center"
                                      >
                                        {/* Name / SKU */}
                                        <div className="flex-1 flex items-center gap-2">
                                          <span className="text-sm text-gray-800 truncate">
                                            {product.name || "Unnamed Product"}{" "}
                                            ({product.sku_number || "N/A"})
                                          </span>
                                        </div>

                                        {/* Controls + Price grouped */}
                                        <div className="flex items-center gap-6">
                                          {/* Quantity controls */}
                                          <div className="flex items-center space-x-1">
                                            <button
                                              onClick={() =>
                                                handleProductQuantityChange(
                                                  idx,
                                                  -1
                                                )
                                              }
                                              className="w-6 h-6 flex items-center justify-center rounded border hover:bg-red-100 transition"
                                            >
                                              –
                                            </button>

                                            {/* 👇 Replace plain span with input */}
                                            <input
                                              type="number"
                                              min="1"
                                              value={product.quantity || 1}
                                              onChange={(e) =>
                                                handleProductQuantityInput(
                                                  idx,
                                                  e.target.value,
                                                  product
                                                )
                                              }
                                              className="w-12 text-center border rounded p-0"
                                            />

                                            <button
                                              onClick={() =>
                                                handleProductQuantityChange(
                                                  idx,
                                                  +1
                                                )
                                              }
                                              className="w-6 h-6 flex items-center justify-center rounded border hover:bg-green-100 transition"
                                            >
                                              +
                                            </button>
                                          </div>

                                          {/* Prices */}
                                          <div className="text-right">
                                            <div className="text-xs text-gray-600">
                                              ₹{" "}
                                              {parseFloat(
                                                product.unit_price || 0
                                              ).toFixed(2)}{" "}
                                              each
                                            </div>
                                            <div className="text-green-700 font-semibold">
                                              ₹{" "}
                                              {parseFloat(
                                                product.total_price || 0
                                              ).toFixed(2)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}

                          {/* Add/Edit Pets & Services Button */}
                          <div className="my-6">
                            <button
                              onClick={handleAddPetsAndServices}
                              className="w-full flex items-center justify-between p-4 border-2 border-dashed border-blue-300 rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all duration-200 group"
                            >
                              <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center group-hover:from-blue-200 group-hover:to-indigo-200 transition-all duration-200">
                                  <FiPlusCircle className="w-5 h-5 text-blue-600" />
                                </div>
                                <span className="font-medium text-gray-700 group-hover:text-blue-700 transition-colors duration-200">
                                  Add Pets & Services
                                </span>
                              </div>
                              <FiArrowRightCircle className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors duration-200" />
                            </button>
                          </div>

                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              fontWeight="bold"
                              mb={0.5}
                              className="flex items-center gap-2"
                            >
                              <NotesIcon
                                sx={{ fontSize: 16, color: "#6b7280" }}
                              />
                              Notes
                            </Typography>
                            <TextField
                              fullWidth
                              multiline
                              rows={3}
                              size="small"
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                              placeholder="Describe concerns, or reason for the visit..."
                              sx={{
                                mb: 1,
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "12px",
                                  backgroundColor: "white",
                                  border: "1px solid #e5e7eb",
                                  "&:hover": {
                                    borderColor: "#6b7280",
                                    boxShadow:
                                      "0 4px 12px rgba(107, 114, 128, 0.15)",
                                  },
                                  "&.Mui-focused": {
                                    borderColor: "#6b7280",
                                    boxShadow:
                                      "0 0 0 3px rgba(107, 114, 128, 0.1)",
                                  },
                                },
                              }}
                            />
                          </Grid>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Totals Section */}
                {(appointmentList.length > 0 ||
  boardingList.length > 0 ||
  vetClinicList.length > 0 ||
  productList.length > 0) && (
  <div className="px-6 py-4 bg-white border-t border-gray-200">
    <TotalsSummary
  totals={{
    ...totalSummary,
    subtotal: Number(totalSummary.subtotal),
    gst: Number(totalSummary.gst),
    total: Number(totalSummary.total),
  }}
  discount={discount}
  setDiscount={setDiscount}
  orderData={{}}
  orderId={null}
  isProductOnlyOrder={false}
  isOrderClosed={false}
  onDiscountUpdated={() => {}}
/>
  </div>
)}

                {/* Footer with 4 buttons matching the image */}
                <div className="p-4 border-t border-gray-200 bg-white">
                  {appointmentList.length > 0 ||
                  boardingList.length > 0 ||
                  vetClinicList.length > 0 ||
                  productList.length > 0 ? (
                    <div className="flex gap-3">
                      <button
                        onClick={handleClose}
                        className="flex-1 inline-flex items-center justify-center px-4 py-3.5 bg-gray-800 text-white font-medium rounded-lg hover:bg-gray-900 transition-all duration-200 text-sm"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleSaveBooking}
                        disabled={saveDisabled}
                        className={`flex-1 inline-flex items-center justify-center px-4 py-3.5 font-medium rounded-lg transition-all duration-200 text-sm gap-2
                                                                        ${
                                                                          saveDisabled
                                                                            ? "bg-blue-300 text-white cursor-not-allowed" // lighter color + no hover
                                                                            : "bg-blue-600 hover:bg-blue-700 text-white"
                                                                        }`}
                      >
                        Save Booking
                      </button>
                      <button
                        onClick={handleSaveAndAddPayment}
                        disabled={saveDisabled}
                        className={`flex-1 inline-flex items-center justify-center px-4 py-3.5 font-medium rounded-lg transition-all duration-200 text-sm gap-2
                                                                        ${
                                                                          saveDisabled
                                                                            ? "bg-purple-300 text-white cursor-not-allowed" // lighter color + no hover
                                                                            : "bg-purple-600 hover:bg-purple-700 text-white"
                                                                        }`}
                      >
                        <MdPayment className="w-4 h-4" />
                        Pay Now
                      </button>
                    </div>
                  ) : (
                    <div className="flex justify-end">
                      <button
                        onClick={handleClose}
                        className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-medium rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                      >
                        <RiCloseCircleFill className="w-4 h-4" />
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        ) : (
        <PetServiceCategoryDrawer
          isOpen={showPetServiceDrawer}
          onClose={() => {
            handleBackFromServiceDrawer();
            setIsServiceEditMode(false);
          }}
          onUpdate={handleSavedServicesData}
          clientId={clientData?._id}
          clientName={`${clientData.firstname} ${clientData.lastname}`}
          clientNumber={`${clientData.phone}`}
          itemData={itemData}
          orderId={enquiryData?._id}
          fromCalendar={true}
          onRefreshData={handleRefreshAppointmentData}
          appointmentStatusRef={appointmentStatusRef}
          autoOpenPetForm={shouldOpenPetForm}
          isServiceEditMode={isServiceEditMode}
        />
      )}


      {showPaymentSection && (
        <PaymentDrawer
          isOpen={showPaymentSection}
          customer={clientData}
          totals={{
            subtotal: Number(totalSummary.subtotal),
            disc: Number(totalSummary.discountAmount),
            gst: Number(totalSummary.gst),
            net: Number(totalSummary.total),
            paid: 0, // Add this - for new orders, paid amount is 0
            remaining: Number(totalSummary.total), // Add this - for new orders, remaining = total
          }}
          onClose={() => setShowPaymentSection(false)}
          onCompletePayment={handleOrderSaveAndPay}
        />
      )}

      {/* <ScheduleDrawer
        isOpen={showBookingDetails}
        onClose={handleCloseScheduleDetails}
        orderId={selectedOrderId}
        mode={`update`}
      /> */}
    </>
  );
};

export default EditEnquiry;


